export default "__VITE_ASSET__mMpgoPuc__"